import NewCustomerHeader from './NewCustomerHeader';
export default NewCustomerHeader;
